export default "__VITE_ASSET__CE24oYBu__"